import common from '../../../../common.js'
import summaryChart from './summarychart.vue'
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  name: 'summaryGraph',

  components: {
    summaryChart
  },

  data() {
    return {
      // サマリグラフの表示形式。累計 or 月別
      graphType: 'month',
      // サマリグラフのデータ。売上高 or 粗利高
      graphDataType: 'amount'
    }
  },

  computed: {
    ...mapGetters('summary', [
      'selectedCategoryId',
      'selectedStoreId',
      'actualSummary',
      'planSummary',
      'startDate',
      'endDate'
    ]),

    /**
     * サマリの開始、終了年月
     */
    graphStartDate() {
      return this.formatDate_(this.startDate)
    },
    graphEndDate() {
      return this.formatDate_(this.endDate)
    },

    /**
     * 実績サマリと計画サマリ
     */
    aSummary() {
      return this.getSummary_(this.actualSummary)
    },
    pSummary() {
      return this.getSummary_(this.planSummary)
    },

    /**
     * グラフ上部の表示金額
     */
    graphSum() {
      const actSum = this.sumSummary_(this.aSummary)
      const planSum = this.sumSummary_(this.pSummary)
      return {
        amount: this.formatMoney_(actSum.amount, planSum.amount),
        profit: this.formatMoney_(actSum.profit, planSum.profit)
      }
    },

    /**
     * サマリグラフ描画用データ
     */
    chartData() {
      let act = this.getGraphData_(this.aSummary, this.graphDataType)
      let plan = this.getGraphData_(this.pSummary, this.graphDataType)

      // 累計表示に変更
      if (this.graphType === 'summary') {
        act = this.chengeGraphSummary_(act)
        plan = this.chengeGraphSummary_(plan)
      }

      return {
        labels: this.getLabels_(),
        backgroundColor: 'white',
        datasets: [{
          label: '実績',
          backgroundColor: '#0b7bfe',
          data: act
        }, {
          label: '計画',
          backgroundColor: '#85bcfc',
          data: plan
        }]
      }
    },

    /**
     * 金額単位
     */
    moneyUnit() {
      return common.VALUE_RATE.label
    }
  },

  methods: {

    /**
     * 日付を「yyyy年 m月」の書式で返却
     */
    formatDate_(date) {
      return date.slice(0, 4) + '年 ' + Number(date.slice(4, 6)) + '月'
    },

    /**
     * 選択した店舗、カテゴリのサマリデータを年月ごとに売上高と粗利高を合算して返却
     * 全てを選択している場合は、全てを合算する
     */
    getSummary_(summary) {
      const sId = this.selectedStoreId
      const cId = this.selectedCategoryId
      const allSid = '00000' // 店舗ID「全て」
      const allCid = '00'    // カテゴリID「全て」
      const dateSummary = {}

      _.forEach(summary, (store, storeId) => {
        if (storeId !== sId && sId !== allSid) return

        _.forEach(store, (category, categoryId) => {
          // 店舗IDとカテゴリIDが両方「全て」の場合、店舗の予算とカテゴリの予算が合算されてしまうため、店舗予算をALL予算とする
          if (categoryId !== cId && (cId !== allCid || storeId === allSid)) return

          _.forEach(category, (date, key) => {
            if (!_.has(dateSummary, key)) {
              dateSummary[key] = {
                amount: date.amount,
                profit: date.profit
              }
            } else {
              dateSummary[key].amount += date.amount
              dateSummary[key].profit += date.profit
            }
          })
        })
      })

      return dateSummary
    },

    /**
     * サマリデータを合計して返却
     */
    sumSummary_(summary) {
      return _(summary).reduce((sum, val) => {
        sum.amount += val.amount
        sum.profit += val.profit
        return sum
      }, { amount: 0, profit: 0 })
    },

    /**
     * 金額の書式設定
     * 金額には3桁カンマ付きで後ろに計画達成率を追記する形で返却
     */
    formatMoney_(act, plan) {
      let rate = '-'
      if (plan > 0) {
        rate = (act / plan * 100).toFixed(1) + ' (%)'
      }
      return `${common.separate_every_3digits(common.change_value_rate(act))} (${this.moneyUnit}) / ${rate}`
    },

    /**
     * サマリグラフのラベルを構築して返却
     * ラベルは1年(12カ月)分作成
     */
    getLabels_() {
      const labels = []
      let startMonth = Number(this.startDate.slice(-2))
      let endMonth = Number(this.endDate.slice(-2))
      while (startMonth !== endMonth) {
        labels.push(`${startMonth}月`)
        if (++startMonth > 12) {
          startMonth = 1
          endMonth++
        }
      }
      return labels
    },

    /**
     * サマリデータをグラフ用データに変換して返却
     */
    getGraphData_(summary, key) {
      const list = []
      let startYear = Number(this.startDate.slice(0, 4))
      let startMonth = Number(this.startDate.slice(-2))
      let endMonth = Number(this.endDate.slice(-2))

      while (startMonth !== endMonth) {
        const date = String(startYear) + (`0${startMonth}`).slice(-2)
        if (_.has(summary, date)) {
          list.push(summary[date][key])
        } else {
          list.push(0)
        }

        if (++startMonth > 12) {
          startYear++
          startMonth = 1
          endMonth++
        }
      }

      return list
    },

    /**
     * サマリグラフの表示形式が累計の場合は、累計に変換して返却
     */
    chengeGraphSummary_(summary) {
      const list = []
      _(summary).reduce((sum, val) => {
        sum += val
        list.push(sum)
        return sum
      }, 0)
      return list
    },

    // 動的css。グラフ表示形式タブ
    cssSelectBtn(type) {
      return this.graphType === type ? '' : 'summary-graph__button--no-select'
    },

    // 動的css。金額表示のボーダー
    cssSelectTabBorder(type) {
      return this.graphDataType === type ? 'summary-graph__tab-border' : ''
    },

    // 動的css。金額表示
    cssSelectTab(type) {
      return this.graphDataType === type ? '' : 'summary-graph__tab--no-select'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/aftersale/dashboard/summarygraph/summarygraph.js